import React from 'react';
import { Navigate } from "react-router-dom";
import authService from '../../_services/AuthService';

export const SecureComponent = ({ component: Component, authenticated, ...rest }) => {
    const tokenExists = authService.loggedIn();
    return tokenExists ? <Component {...rest} /> : <Navigate to="../login/" replace />;
};
